import React, { useRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { useInvokeDenaliAssistant } from '../../../../api/denaliAssistant'
import MessageInput from '../common/MessageInput'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import Greetings from '../Landing/Greetings'
import SuggestionList from './SuggestionList'

const useStyles = makeStyles((theme) => ({
  landingContainer: {
    height: '100%',
    width: '100%'
  }
}))

function MobileLandingPage () {
  const classes = useStyles()
  const history = useHistory()
  const messageInputRef = useRef(null)

  // Mutations
  const invokeMutation = useInvokeDenaliAssistant()

  const handleSendMessage = useCallback(async (message, attachments = []) => {
    if (!message.trim()) return

    try {
      // Send the message - thread will be created automatically if needed
      const result = await invokeMutation.mutateAsync({
        prompt: message,
        attachments,
        context: {
          currentView: 'ai-assistant-chat'
        },
        options: {
          modelStrategy: 'balanced',
          streamResponse: true,
          includeTrailOfThought: true
        }
      })

      // If this was a new thread, update URL to the new thread
      if (result.threadId) {
        history.replace(`/denali-ai/chat/${result.threadId}`)
      }
    } catch (error) {
      console.error('Failed to send message:', error)
      // TODO: Show error toast
    }
  }, [invokeMutation, history])

  return (
    <div className={classes.landingContainer}>
      <FlexColumn className='gap-md mt-10 items-center' style={{ width: '100%', height: 'calc(100% - 15vh)' }}>
        <FadeIn className='w-full'>
          <Greetings isMobile />
        </FadeIn>
        <FadeIn delay={0.2} className='w-full'>
          <div className='px-2'>
            <MessageInput
              ref={messageInputRef}
              onSend={handleSendMessage}
              placeholder='What do you want to know?'
              minRows={3}
            />
          </div>
        </FadeIn>
        <FadeIn delay={0.4}>
          <SuggestionList
            take={3}
            onSuggestionClick={(prompt) => {
              // Set the suggestion in the input so user can review/modify before sending
              messageInputRef.current?.setValue(prompt)
            }}
          />
        </FadeIn>
      </FlexColumn>
    </div>
  )
}

export default MobileLandingPage
